var map = {
	"./1.png": 1394,
	"./2.png": 1395,
	"./3.png": 1396,
	"./avatar.png": 1397,
	"./crown-1.png": 1202,
	"./crown-2.png": 1203,
	"./crown-3.png": 1204,
	"./header-bg.png": 1094,
	"./like.png": 1065,
	"./logo.png": 1095,
	"./no-ranking.png": 1205,
	"./prize-bg.png": 1398,
	"./prize-top-bg.png": 1399,
	"./ranking-bg-1.png": 1400,
	"./ranking-bg-2.png": 1401,
	"./ranking-bg-3.png": 1402,
	"./start.png": 1096,
	"./top-up-bottom.png": 1403,
	"./top-up-popup.png": 1404,
	"./top-up.png": 1405,
	"./unlike.png": 1206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2195;